import { WEEKDAY_SHORT_SUN_FIRST } from "@utils/dayUtill";
import { images } from "@/assets/img/imagesMap";
import ModalWeeklyOffThCalendarDay from "./ModalWeeklyOffThCalendarDay";

function ModalWeeklyOffTableHeader({
  currentYear,
  currentMonth,
  holidayDates,
  nursesCount,
}: {
  currentYear?: number;
  currentMonth?: number;
  holidayDates: string[];
  nursesCount: number;
}) {
  const lastDay =
    currentYear &&
    currentMonth &&
    new Date(currentYear, currentMonth, 0).getDate();
  const firstDayFactor =
    currentYear &&
    currentMonth &&
    new Date(currentYear, currentMonth - 1, 1).getDay();
  const formatDate = (year?: number, month?: number, day?: number) => {
    const mm = String(month).padStart(2, "0"); // '02'
    const dd = String(day).padStart(2, "0"); // '06'
    return `${year}-${mm}-${dd}`;
  };

  return (
    <div className="flex border-b border-border">
      <div className="rt_nurseInfo_flexWrap">
        {/* 인원수 */}
        <div className="flex justify-center gap-[6px] text-[14px] text-[#939399] !pb-[10px] leading-[--shiftCode_size] padding_hover_bg_vertical !items-end">
          <img
            src={images.user}
            alt=""
            className=""
            style={{ height: "1em" }}
          />
          {nursesCount}
        </div>
        <div className="rt_nurse_name padding_hover_bg_vertical !items-end !pb-[10px]">
          <div className="text-[14px] px-3 pr-4 font-pretendard text-[#999999]">
            직군
          </div>
        </div>
        <div className="rt_nurse_name padding_hover_bg_vertical !items-end !pb-[10px] w-[58px]">
          <div className="text-[14px] px-3 pr-4 font-pretendard text-[#999999]">
            이름
          </div>
        </div>

        <div className="rt_whiteSpace rt_bg_hover_row !w-[2px]"></div>
      </div>

      <div className={`flex pl-[7px]`}>
        {lastDay &&
          firstDayFactor != null &&
          Array.from({ length: lastDay }, (_, i) => {
            const dateStr = formatDate(currentYear, currentMonth, i + 1);
            const dayIndex = (i + firstDayFactor) % 7;
            const isHoliday = holidayDates.includes(dateStr);
            const holiday = isHoliday
              ? "holiday"
              : dayIndex === 6
                ? "sat"
                : dayIndex === 0
                  ? "sun"
                  : "";
            return (
              <ModalWeeklyOffThCalendarDay
                key={i}
                day={i + 1}
                holiday={holiday}
                weekDay={WEEKDAY_SHORT_SUN_FIRST[dayIndex]}
              />
            );
          })}
      </div>
    </div>
  );
}

export default ModalWeeklyOffTableHeader;
